import { Button } from '@orbita-ui/core';
import { CuentaSelector } from 'core/cuenta/components/CuentaSelector/CuentaSelector';
import { useContext, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { FormWithValidation } from 'shared/form';
import { UserListContext } from 'user/context/UserListContext';
import { SearchUsersRequest } from 'user/models/SearchUsersRequest';

interface FilterUsersFormValue {
  numeroCuentaControlada: string;
  username: string;
  detalle: string;
}

const mapFormData = (formData: FilterUsersFormValue): SearchUsersRequest => {
  return {
    numeroCuentaControlada: formData.numeroCuentaControlada,
    username: formData.username,
    detalle: formData.detalle,
  };
};

const EMPTY_FORM_VALUES = {
  numeroCuentaControlada: '',
  username: '',
  detalle: '',
};

export const FilterUsersForm = () => {
  const { searchParams, reloadToken, searchUsers } = useContext(UserListContext);

  const methods = useForm<FilterUsersFormValue>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: EMPTY_FORM_VALUES,
  });

  useEffect(() => {
    if (searchParams) {
      // reseteamos el formulario con los valores que vienen de la URL
      methods.reset({
        numeroCuentaControlada: searchParams.numeroCuentaControlada || '',
        username: searchParams.username || '',
        detalle: searchParams.detalle || '',
      });
    }
  }, [searchParams, methods]);

  const handleSearch = (data: FilterUsersFormValue) => {
    searchUsers(mapFormData(data));
  };

  return (
    <FormWithValidation
      reactFormHookMethods={methods}
      onSubmit={handleSearch}
      className="m-3"
    >
      <Row>
        <Col>
          <FormWithValidation.TextInput
            name="username"
            label="Código de usuario"
            placeholder="Ingrese un texto"
            fullWidth
          />
        </Col>
        <Col>
          <FormWithValidation.TextInput
            name="detalle"
            label="Detalle"
            placeholder="Ingrese un texto"
            fullWidth
          />
        </Col>
        <Col>
          <CuentaSelector
            name="numeroCuentaControlada"
            label="Cuenta controlada"
            // filtros={{
            // }}
            reloadToken={reloadToken}
          />
        </Col>
      </Row>

      <Row className="d-flex justify-content-end">
        <Button
          type="button"
          className="me-2"
          color="destructive"
          variant="outline"
          onClick={() => methods.reset(EMPTY_FORM_VALUES)}
        >
          Limpiar
        </Button>
        <Button className="me-2" color="primary" variant="filled" type="submit">
          Consultar
        </Button>
      </Row>
    </FormWithValidation>
  );
};
